import { MutableRefObject, useEffect } from 'react';

export const useOnHoverOutside = (
  ref: MutableRefObject<any>,
  handler: (e?: MouseEvent) => void
) => {
  useEffect(() => {
    const listener = (event: MouseEvent) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document.addEventListener('mouseover', listener);
    return () => {
      document.removeEventListener('mouseout', listener);
    };
  }, [ref, handler]);
};
